import { SeeqNames } from 'generated-seeqnames/app.constants.seeqnames';
import { sqItemsApi } from '@seeqdev/api/endpoint/ItemsApi';

export const updateTableDefinitionName = async ({
  tableDefinitionId,
  name,
}: {
  tableDefinitionId: string;
  name: string;
}) => await sqItemsApi.setProperty({ value: name }, { id: tableDefinitionId, propertyName: SeeqNames.Properties.Name });
